import { SxStyles } from '../../../types';
import theme from '../../../theme';
import { getResponsiveSize } from '../../../utils';

export const accordionStyles: SxStyles = {
  container: {
    '& .MuiPaper-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '& .interactive-settings': {
        width: '100%',
      },
      '& .MuiButtonBase-root': {
        '& .MuiAccordionSummary-content': {
          m: 1,
        },
      },
    },
    '& .accordion': {
      paddingBottom: getResponsiveSize(12),

      '& .accordion-summary-background': {
        backgroundColor: '#517EC5',
      },
      '& .accordion-summary-client-background': {
        backgroundColor: '#586499',
      },
      '& .accordion-summary': {
        zIndex: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        m: 0,
        p: 0,
        px: getResponsiveSize(4),
        py: getResponsiveSize(5),
        '& .MuiAccordionSummary-content': {
          display: 'flex',
          alignItems: 'center',
        },
        '& .arrow-icon': {
          transform: 'rotate(180deg)',
          width: '46px',
        },
        '& .arrow': {
          fontSize: '40px',
        },
        '&.Mui-expanded': {
          borderRadius: '20px 20px 0 0 ',
        },
        '&:not(.Mui-expanded)': {
          borderRadius: '20px',
          m: 0,
        },
        '& .summary-icon-container': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#41659e',
          borderRadius: '50%',
          mr: getResponsiveSize(9),
          width: 'auto',
          height: 'auto',
          p: 1,

          '& .icon': {
            width: getResponsiveSize(22),
            height: getResponsiveSize(22),
            p: 0.2,
          },
        },
        '& .summary-text-container': {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          '& .text-container-title': {
            fontFamily: theme.typography.fontFamily,
            fontSize: getResponsiveSize(16),
            color: theme.palette.myPrimary?.white,
            lineHeight: getResponsiveSize(22),
            fontWeight: 400,
          },
          '& .text-container-details': {
            fontFamily: theme.typography.fontFamily,
            fontSize: getResponsiveSize(13),
            color: theme.palette.myPrimary?.white,
            opacity: '0.569',
            lineHeight: 1.1,
            fontWeight: 400,
          },
        },
        '& .MuiAccordionSummary-expandIconWrapper': {
          color: theme.palette.myPrimary?.white,
        },
      },
      '& .notes': {
        pb: getResponsiveSize(10),
        pt: getResponsiveSize(10),
        px: getResponsiveSize(20),
        width: '100%',
        display: 'flex',
        borderRadius: '0 0 24px 24px',
        backgroundColor: '#f5f5f5',
        '& .general-score-container': {
          display: 'flex',
          flexDirection: 'column',
        },
        '& .notes-container': {
          width: '100%',

          '& .textarea': {
            width: '100%',
          },
          '& .save-notification': {
            display: 'flex',
            justifyContent: 'end',
          },
        },
      },
      '& .accordion-details': {
        pb: getResponsiveSize(32),
        pt: getResponsiveSize(16),
        px: getResponsiveSize(45),
        width: '100%',
        display: 'flex',
        borderRadius: '0 0 24px 24px',
        backgroundColor: '#f5f5f5',
        filter: 'drop-shadow(0.877px 1.798px 5px rgba(0,0,0,0.2))',

        '& .general-score-container': {
          display: 'flex',
          flexDirection: 'column',
        },
      },
      '& .accordion-details-client-view': {
        p: 0,
        backgroundColor: '#555555',
        borderBottomLeftRadius: '24px',
        borderBottomRightRadius: '24px',
        zIndex: 1,
        position: 'relative',
        '&.child-theme': {
          backgroundImage: 'url(/assets/phaser/images/child_bg_emptylandscape.png)',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: 'transparent',
        },
        '& .content': {
          display: 'flex',
          height: getResponsiveSize(200),
          overflow: 'hidden',
          '& .spinner-container': {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
            '& .MuiCircularProgress-root ': {
              color: theme.palette?.myPrimary?.lightBlue100,
            },
          },
        },
        '& #client-task-container': {
          width: '100%',
          height: '100%',
          borderBottomLeftRadius: '20px',
          borderBottomRightRadius: '20px',
          zIndex: 3,
        },
      },

      '& .MuiButtonBase-root': {},
    },
    '& .client-preview-accordion': {
      paddingBottom: getResponsiveSize(6),
    },
    ['@media screen and (max-width: 1441px)']: {
      '& .accordion': {
        // '& .accordion-details': {
        //   pb: getResponsiveSize(22),
        //   pt: getResponsiveSize(16),
        //   px: getResponsiveSize(22),
        // },
      },
    },
  },
};
